import { render, staticRenderFns } from "./addCase.vue?vue&type=template&id=cb2e7fcc&scoped=true&"
import script from "./addCase.vue?vue&type=script&lang=js&"
export * from "./addCase.vue?vue&type=script&lang=js&"
import style0 from "./addCase.vue?vue&type=style&index=0&id=cb2e7fcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2e7fcc",
  null
  
)

export default component.exports